import { Resource as e, API as o } from "@coveo/platform-client";
const t = class t extends e {
  /**
   * Returns a paginated list of security identities for the specified project.
   *
   * @param {string | undefined} projectId ID of the project for which to retrieve security identities.
   * @param {ListSecurityIdentitiesOptions} options Options to filter and paginate the results.
   * @returns {Promise<PageModel<SecurityProviderModelWithStatus>>} Paginated list of security providers for the specified project.
   */
  listProvidersByProjectId(r, i = {}) {
    return this.api.get(
      this.buildPath(`${t.baseUrl}/batch/project`, {
        ...i,
        projectId: r
      })
    );
  }
  /**
   * Returns all security providers present in a project. This endpoint does not support pagination, filtering, or ordering - the client should handle these operations.
   *
   * @param {string | undefined} projectId ID of the project for which to retrieve security identities.
   * @returns {Promise<SecurityProviderModelWithStatus[]>} List of all security providers for the specified project.
   */
  listAllProvidersByProjectId(r) {
    return this.api.get(
      this.buildPath(`${t.baseUrl}/project`, {
        projectId: r
      })
    );
  }
};
t.baseUrl = `/rest/organizations/${o.orgPlaceholder}/securityproviders`;
let s = t;
export {
  s as SecurityCacheInternalResource
};
//# sourceMappingURL=SecurityCacheInternalResource.js.map
